import { render, staticRenderFns } from "./myAttendanceRecord.vue?vue&type=template&id=44684c4e&"
import script from "./myAttendanceRecord.vue?vue&type=script&lang=ts&"
export * from "./myAttendanceRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports